export default "__VITE_ASSET__d6d1a24a__"